import React from "react"; 
import PolicyFooter from './../Common/PolicyFooter'; 
import { connect } from 'react-redux';
import {fetchOrderData,fetchOrderListing} from '../../redux/actions/orderAction'
import {PRODUCTION_PATH,ORDERSEARCH_PAGE,CLERKLOGIN_PAGE,ROWS_PER_PAGE,PAGE_RANGE_DISPLAYED} from './../../AppConfig'
 
import Pagination from "react-js-pagination";  

class OrderListing extends React.Component {
    constructor(props) {
        super(props);
        this.state = { 
            storeClerkToken : window.sessionStorage.getItem('storeClerkToken'),
            storeId : window.sessionStorage.getItem('storeId'),
            orderListDetails : {},
            orderListHeader:{},
            activePage: 1,
            rowsPerPage: ROWS_PER_PAGE, 
            pageRangeDisplayed: PAGE_RANGE_DISPLAYED,
            loader: false,
            loadingId: ''

        }     
        this.getOrderDetails = this.getOrderDetails.bind(this); 
        this.getRMADetails = this.getRMADetails.bind(this); 
        this.handlePageChange = this.handlePageChange.bind(this);

    }
    // pagination  
    handlePageChange(pageNumber) {

        if(pageNumber!== this.state.activePage){                        
            this.setState({
                activePage: pageNumber
            });   
            let orderSearchInputForClerk ={
                        "firstName":this.state.orderListHeader.firstName.trim(),
                        "lastName" :this.state.orderListHeader.lastName.trim(),
                        "emailAddress" : this.state.orderListHeader.emailAddress.trim(),
                        "orderIdentifier":this.state.orderListHeader.orderIdentifier.trim(), 
                        "storeId": this.state.storeId,
                        "storeClerkToken":this.state.storeClerkToken,
                        "activePage":pageNumber,
                        "rowsPerPage":this.state.rowsPerPage
                    }                
            this.props.fetchOrderListing(orderSearchInputForClerk,this.props);
        }       
      }

    // redirect to the Order detail page and open RMA PopUp
    getRMADetails(orderId,emailAddress,returnId){

        let orderData= {"email":emailAddress,"orderIdentifier" : orderId,
                         "storeId":this.state.storeId,"returnIdFromOrderListing":returnId }; 
        this.props.fetchOrderData(orderData,this.props); 
    }

    componentWillMount() {

        // redirect to the Login page when the clerk directly comes to the Order Listing page
        if (!this.state.storeClerkToken) {
            let loginURL = PRODUCTION_PATH + this.state.storeId + CLERKLOGIN_PAGE;
            this.props.history.push(loginURL);
        }  
        // after login if the clerk directly comes orderdetails page it will redirect to order search page
        else if(this.props.orderListing===null) {
            let orderSearchUrl = PRODUCTION_PATH + this.state.storeId + ORDERSEARCH_PAGE;
            this.props.history.push(orderSearchUrl);
        }
            if(this.props.orderListing){
                if (this.props.orderListing.orderListDetails) {
                    this.setState({
                        orderListDetails: this.props.orderListing.orderListDetails,
                    }); 
                } 
                if (this.props.orderListing.orderListHeader) {
                    this.setState({
                        orderListHeader: this.props.orderListing.orderListHeader,
                    }); 
                }      
            }               
    }

     //update the state value
     componentWillReceiveProps(nextProps){
        
        if(nextProps.orderListing){
            if (nextProps.orderListing.orderListDetails) {
                this.setState({
                    orderListDetails: nextProps.orderListing.orderListDetails,
                }); 
            } 
            if (nextProps.orderListing.orderListHeader) {
                this.setState({
                    orderListHeader: nextProps.orderListing.orderListHeader,
                }); 
            }     
        }          
    }

    // Fetch order details when click order Id
    async getOrderDetails(orderId,emailAddress){
        this.setState({
            loader: true,
            loaderId: orderId
        });
        let orderData= {"email":emailAddress,"orderIdentifier" : orderId,
                        "storeId":this.state.storeId }; 
        await this.props.fetchOrderData(orderData,this.props);
        this.setState({
            loader: false,
            loaderId: ''
        });
    }


    render() {  

        return (
            <React.Fragment>
                {this.state.loader &&
                    <React.Fragment>
                        <div className="loading">Loading&#8230;</div>
                    </React.Fragment>
                }
                <main id="main">
                    <div className="container">
                        <div className="page-title">
                            ORDERS
	                    </div>
                        <div className="row">
                            <div className="col">
                                <table className="orderList table table-hover mt-60">
                                    <thead>
                                        <tr>
                                            <th>ORDER NUMBER</th>
                                            <th>SHIP DATE</th>
                                            <th>CUSTOMER NAME</th>
                                            <th>RETURN ELIGIBLE</th>
                                            <th align="right">ITEMS IN ORDER</th>
                                            <th align="right">ORDER TOTAL</th>
                                            <th>RETURN NUMBER </th>
                                        </tr>
                                    </thead>
                                    {this.state.orderListDetails.length>0 &&
                                    <tbody>
                                    {this.state.orderListDetails.map((items, index) => (
                                        <tr key={index}>
                                            <td><div onClick={() => this.getOrderDetails(items.OrderNumber, items.emailAddress)}  className="backlink returnId-link">{items.OrderNumber}</div></td>
                                            <td>{items.shipDate}</td>
                                            <td>{items.customerName}</td>
                                            <td>{items.orderReturnEligibility}</td>
                                            <td align="right">{items.noOfItemsInOrder}</td>
                                            <td align="right">${items.orderTotal.toFixed(2)} </td>
                                            <td>                                              
                                                {items.returnIdMap &&
                                                <React.Fragment>
                                                {items.returnIdMap.map((returnId,index) => (  
                                                        <span key={index} onClick={() => this.getRMADetails(items.OrderNumber,items.emailAddress,returnId)} className="backlink returnId-link"> 
                                                                {returnId}
                                                                {items.returnIdMap.length-1 !== index &&
                                                                <React.Fragment>, </React.Fragment>
                                                                }
                                                        </span>
                                                    ))}
                                                </React.Fragment>
                                               } 
                                            </td>
                                        </tr> 
                                    ))}
                                    </tbody>
                                    }
                                </table>
                            </div>
                        </div>                       
                    </div>
                    <div>         
      </div> 

       {/* pagination  */}

    {/* hide the pagination if the totalItemsCount less then rowsPerPage                             */}
      {this.props.orderListing &&
      <React.Fragment>
      {this.state.rowsPerPage < this.props.orderListing.orderListHeader.totalItemsCount &&
            <Pagination
                activePage={this.state.activePage}
                itemsCountPerPage={this.state.rowsPerPage}
                totalItemsCount={this.props.orderListing.orderListHeader.totalItemsCount}
                pageRangeDisplayed={this.state.pageRangeDisplayed}
                onChange={this.handlePageChange}
                />
      }
      </React.Fragment>
    }
        </main>

            <PolicyFooter />

            </React.Fragment>
        );
    }
}

const mapStateToProps = (state) => ({
    orderListing: state.orderDataDetails.orderListing,
    policyData: state.storeSettingData.storeDesign,
});

export default connect(mapStateToProps, {fetchOrderData,fetchOrderListing})(OrderListing); 



// WEBPACK FOOTER //
// ./src/components/OrderListing/OrderListing.js